define('backbone_collection_view_row.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('backbone_collection_view_row', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " <div class=\"backbone-collection-view-row\"><div data-type=\"backbone.collection.view.cells\"></div></div>  ";
},"useData":true}, 'extensions/SC/Bridge/3.2.1/', 'extensions/SC/Bridge/3.2.1/', Handlebars);
});